<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
		<br>
		<div class="col-lg-12">
			<div class="card card-danger card-outline">
				<div class="card-header">
					<div class="card-title">Search Winner</div>
					<div class="card-tools">
      <!-- Collapse Button -->
      					<!-- <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button> -->
    				</div>
				</div>
				<div class="card-body">
					<div class="col-lg-12 float-left">
						<div class="row">
							<div class="col-sm-6">
								<div class="form-group">
									<label>Phone</label>
									<input type="number" class="form-control" placeholder="Enter the phone number" v-model="phone" min="0">
								</div>
							</div>
							<div class="col-sm-6">
								<div class="form-group">
									<label>Gift Code</label>
									<input type="number" class="form-control" placeholder="Enter the Gift Code" v-model="gift_code" min="0">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-sm-4">
								<button class="btn btn-danger" style="width:100% !important;" @click="getAllAllotments('/api/getAllGiftAllotments')">Search</button>
							</div>
							<!-- <div class="col-sm-4">
								<button class="btn btn-success" style="width:100% !important;" @click="getAllotmentsExport">Export</button>
							</div> -->
							<div class="col-sm-4">
								<button class="btn btn-secondary" style="width:100% !important;" @click="reset">Reset</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<br>
		<div class="col-lg-12">
			<div class="card card-danger card-outline">
				<div class="card-body overflow-auto">
								<table class="table table-hover table-striped table-bordered">
									<thead>
										<tr>
											<th scope="col">Winner</th>
											<th scope="col">Phone</th>
											<th scope="col">Rule</th>
											<th scope="col">Alloted Gift</th>
											<th scope="col">Given to Winner</th>
											<th scope="col">Notes</th>
											<th scope="col">Manage</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="r in allotments">
											<td>{{r.gift_registration.first_name}} {{r.gift_registration.last_name}}</td>
											<td>{{r.phone}}</td>
											<td>{{r.gift_registration.category}}, {{r.gift_registration.division}}</td>
											<td>{{r.gift_rule.assigned_gift}}</td>
											<td>
												<p v-if="r.given_to_customer == 0">No</p>
												<p v-else-if="r.given_to_customer == 1">Yes</p>
											</td>
											<td>{{r.notes}}</td>
											<td>
												<button class="btn btn-primary" @click="giveGiftPrompt(r)" v-if="r.given_to_customer == 0">Given</button>
											</td>
										</tr>
									</tbody>
									<tfoot>
										<pagination :pagination="pagination"
										 	@prev="getAllotments(pagination.prevPageUrl)"
											@next="getAllotments(pagination.nextPageUrl)"
										></pagination>
									</tfoot>
								</table>
					</div>
					<div class="card-footer">

					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->

<div class="modal" tabindex="-1" role="dialog" id="givemodal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Gift Given</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h4>{{title}}</h4>
        <div class="form-group">
        	<input type="text" v-model="notes" placholder="Enter the notes" class="form-control">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="giveGift">Give</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 import Pagination from '../../pagination.vue';
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        components: {pagination:Pagination},

        created(){
        	// this.getCampaign();
        	// this.getAllotments();
        	/*this.getCategories();
        	this.getProducts();
        	this.getDivisions();*/
        },

        data(){
        	return {
        		allotments: [],
        		categories: [],
        		//products: [],
        		//divisions: [],
        		errors: [],
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
         		//product: null,
         		//category: null,
         		//division: null,
         		//from: null,
         		//to: null,
         		phone: null,
				gift_code: null,
         		//itemcode: null,
         		title: '',
         		allotment_id: '',
         		notes: ''
        	}
        },

        methods: {
        	getCampaign(){
        		axios.post("/api/getGiftCampaign", {id: this.$route.params.id})
        		.then(response => {
        			this.campaign = response.data;
        		});
        	},

        	getAllAllotments(url="/api/getAllGiftAllotments"){
        		axios.post(url, {
        			//product: this.product,
		       		//category: this.category,
		       		//division: this.division,
		       		phone: this.phone,
					gift_code: this.gift_code
        		})
        		.then(response => {
        			this.allotments = response.data.data.data;
        			this.configPagination(response.data.data);
        		});
        	},

        	getAllotmentsExport(){
        		axios({
        			url: "/api/getGiftAllotmentsExport",
        			data: {
		      			campaign: this.$route.params.id,
		      			//product: this.product,
				     		//category: this.category,
				     		//division: this.division,
				     		from: this.from,
				     		to: this.to,
				     		phone: this.phone,
				     		given: this.given
				     	},
				     	method: 'post',
							responseType: 'blob'
        		})
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Report Generated'
        			})
        			var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			saveAs(response.data, "allotments_report.xlsx");
        		});
        	},

        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

    			giveGiftPrompt(allotment){
    				this.allotment_id = allotment.id;
    				this.title = allotment.gift_rule.assigned_gift+" is given to "+allotment.gift_registration.first_name+" "+allotment.gift_registration.last_name+" :: "+allotment.phone+" - Gift Code: "+allotment.id;
    				$("#givemodal").modal("show");
    			},

    			giveGift(){
    				axios.post("/api/giftGiven", {id: this.allotment_id, notes: this.notes})
    				.then(() => {
    					toast.fire({
    						icon: 'success',
    						title: 'Gift Given!'
    					});
    					$("#givemodal").modal("hide");
    					this.getAllAllotments();
    				});
    			},

        	/*getCategories(){
        		axios.post("/api/getGiftCategories")
        		.then(response => {
        			this.categories = response.data;
        		});
        	},

        	getProducts(){
        		axios.post("/api/getMasterProductList")
        		.then(response => {
        			this.products = response.data;
        		});
        	},

        	getDivisions(){
        		axios.post("/api/getGiftSubCategories")
        		.then(response => {
        			this.divisions = response.data;
        		});
        	},*/

        	reset(){
        		/*this.product = null;
         		this.category = null;
         		this.division = null;

         		this.itemcode = null;*/
         		this.phone = null;
         		this.from = null;
         		this.to = null;
         		this.given = null;
				this.allotments = null;
         		// this.getAllotments();
        	}
        }
    }
</script>
